var map = {
	"./dataCenter_pic.png": "e298",
	"./ico_choice.png": "0897",
	"./ico_home.png": "f0b9",
	"./ico_list.png": "b0fb",
	"./nav_1.png": "4c6d",
	"./nav_10.png": "e654",
	"./nav_11.png": "ce5e",
	"./nav_12.png": "0559",
	"./nav_2.png": "cb68",
	"./nav_2_title.png": "af7b",
	"./nav_3.gif": "99f7",
	"./nav_3.png": "542c",
	"./nav_4.png": "b1e4",
	"./nav_5.png": "73df",
	"./nav_6.png": "c997",
	"./nav_7.png": "a462",
	"./nav_8.png": "1829",
	"./nav_9.png": "fed5",
	"./onlineDrainage_pic.png": "0be1",
	"./onlineDrainage_star.png": "d1a1",
	"./page_bg_aiDetection.png": "313a",
	"./page_bg_dataCenter.png": "2c89",
	"./page_bg_establishment.png": "7899",
	"./page_bg_investment.png": "5edd",
	"./page_bg_motivateGrowth.png": "162b",
	"./page_bg_onlineDrainage.png": "392a",
	"./page_bg_onlineDrainage2.png": "2694",
	"./page_bg_patrolShop.png": "2a6c",
	"./page_bg_peopleCount.png": "ec42",
	"./page_bg_smartAds.png": "2ecd",
	"./page_bg_smartOA.png": "ade7",
	"./page_bg_storeVisit.png": "f8b1",
	"./page_bg_videoTracing.png": "fcbb",
	"./peopleCount_preview.png": "6e5b",
	"./storeVisit_bg.png": "7ad7",
	"./storeVisit_pic.png": "907e",
	"./storeVisit_star.png": "ef10",
	"./wdz_pc_play_icon_20220118.png": "e606"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";